import { render, staticRenderFns } from "./objNumberSelected.vue?vue&type=template&id=26b8260b&"
import script from "./objNumberSelected.vue?vue&type=script&lang=ts&"
export * from "./objNumberSelected.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports